import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between ma-4" }
const _hoisted_2 = { class: "d-flex" }

import { ref, watch } from "vue";
import { ApiMap } from "@/api/type";
import { useApi } from "@/api/handler";
import { game, proposal, team } from "@/api";
import SubmitPropOne from "@/components/proposal/vote/SubmitPropOne.vue";
import store from "@/store";
import SubmitVote from "@/components/proposal/vote/SubmitVote.vue";
import TileSelect from "../TileSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PropVoteOne',
  props: {
    data: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const GameStatus = ref<ApiMap["/game/status/:id"]["resp"] | null>(null);
const showOverlay = ref<boolean>(false);
const teamList = ref<ApiMap["/team/game/:id"]["resp"]["teams"]>([]);
const proposalNum = ref<number | null>(null);

const proposalList = ref<ApiMap["/proposal/upload/first"]["req"]["proposals"]>(
  []
);
const voteForm = ref<Array<{ data: string; teamId: number }>>([]);
const proposalIndex = ref<number>(0);
const voteMap = new Map<
  number,
  { teamId: number; proposalId: number; score: number }[]
>();
const removedList = ref<Array<number>>([]);
let isTile = ref(false);
const tileOptions = ref<{ label: string; value: number }[]>([]);

function handleEditProp(index: number) {
  proposalIndex.value = index;
  showOverlay.value = true;
}

function handleVote(
  input: { teamId: number; proposalId: number; score: number }[]
) {
  voteMap.set(proposalIndex.value, input);
  showOverlay.value = false;
}

function ProposalStatus(): number {
  if (!GameStatus.value) return 0;
  if (GameStatus.value.proposalStage < 3) return GameStatus.value.proposalStage;
  else if (GameStatus.value.proposalStage === 3) {
    if (
      proposalList.value &&
      proposalList.value.filter((item: any) => item.isSelected).length > 0
    )
      return 4;
    else return 3;
  } else return 5;
}

function handleSubmitPropOne(payload: {
  id: number;
  ids: number[];
  score: number[];
}) {
  proposalList.value[proposalIndex.value] = {
    proposerTeamId: payload.id,
    involvedTeamIds: payload.ids,
    scoreDistribution: payload.score,
  };
  showOverlay.value = false;
}

function GetTableData() {
  if (ProposalStatus() === 4)
    return proposalList.value
      ? proposalList.value.map((item: any) => ({
          提出提案: `第 ${item.proposerTeamId} 组`,
          参与小组: item.involvedTeamIds
            .map((i: number) => `第 ${i} 组`)
            .join("，"),
          分值分配: item.scoreDistribution
            .map((i: number) => `${i} 分`)
            .join("，"),
          总票数: `${item.voteCount} 票`,
          是否被选中: item.isSelected,
        }))
      : [];
  else
    return proposalList.value
      ? proposalList.value.map((item: any) => ({
          提出提案: `第 ${item.proposerTeamId} 组`,
          参与小组: item.involvedTeamIds
            .map((i: number) => `第 ${i} 组`)
            .join("，"),
          分值分配: item.scoreDistribution
            .map((i: number) => `${i} 分`)
            .join("，"),
          操作: true,
        }))
      : [];
}

const useProposalList = () => {
  if (!GameStatus.value) return;
  if (GameStatus.value.proposalRound === 0) return;
  useApi({
    api: proposal.ProposalList(
      GameStatus.value.id,
      GameStatus.value.proposalRound
    ),
    onSuccess: (resp) => {
      proposalList.value = resp.data as ApiMap["/proposal/list"]["resp"];
      voteForm.value = proposalList.value.map((item) => ({
        data: "",
        teamId: item.proposerTeamId,
      }));
    },
  });
};

const useTeamList = () => {
  if (!GameStatus.value) return;
  useApi({
    api: team.TeamList(GameStatus.value.id),
    onSuccess: (resp) => {
      teamList.value = (
        resp.data as ApiMap["/team/game/:id"]["resp"]
      ).teams.filter((item: any) => !removedList.value.includes(item.teamId));
    },
  });
};

const useSubmitProposal = () => {
  if (!proposalNum.value) {
    store.dispatch("snackBarModule/showError", "请填写参与的小组个数");
    return;
  }
  useApi({
    api: proposal.FirstProposal({
      gameId: GameStatus.value!.id,
      num: Number(proposalNum.value) ?? 0,
      proposals: proposalList.value,
    }),
    onSuccess: () => {
      emits("update");
    },
    tip: "上传成功",
  });
};

const getVotesList = (): ApiMap["/proposal/vote"]["req"]["votes"] => {
  let votesList: ApiMap["/proposal/vote"]["req"]["votes"] = [];
  voteMap.forEach((value) => {
    votesList.push(...value);
  });
  return votesList;
};
function getTeamIdByProposalId(proposalId: number) {
  const vote = proposalList.value.find((v) => v.id === proposalId);
  return vote ? vote.proposerTeamId : null;
}

const useSubmitVote = () => {
  const votesList = getVotesList();
  if (new Set(votesList.map((value) => value.teamId)).size < votesList.length) {
    store.dispatch("snackBarModule/showError", "存在重复投票");
    return;
  }

  const voteCountMap: Record<number, number> = {};
  votesList.forEach((vote) => {
    voteCountMap[vote.proposalId] =
      (voteCountMap[vote.proposalId] || 0) + vote.score;
  });
  const maxVote = Math.max(...Object.values(voteCountMap));
  const topProposals = Object.entries(voteCountMap)
    .filter(([, count]) => count === maxVote)
    .map(([proposalId]) => Number(proposalId));
  if (topProposals.length > 1) {
    isTile.value = true;
    tileOptions.value = topProposals.map((id) => ({
      label: `${getTeamIdByProposalId(id)}组提案`,
      value: id,
    }));
  } else {
    useApi({
      api: proposal.SubmitVote({
        gameId: GameStatus.value!.id,
        round: GameStatus.value!.proposalRound,
        votes: votesList,
        hasTie: isTile.value,
      }),
      onSuccess: () => {
        useProposalList();
      },
      tip: "上传成功",
    });
  }
};
const useSubmitTile = (id: number) => {
  const votesList = getVotesList();
  useApi({
    api: proposal.SubmitVote({
      gameId: GameStatus.value!.id,
      round: GameStatus.value!.proposalRound,
      hasTie: isTile.value,
      votes: votesList,
      winnerProposalId: id,
    }),
    onSuccess: () => {
      emits("update");
    },
    tip: "上传成功",
  });
};
const useRemovedList = () => {
  if (!GameStatus.value) return;
  useApi({
    api: game.RemoveList(GameStatus.value.id),
    onSuccess: (resp) => {
      removedList.value = resp.data as Array<number>;
      useTeamList();
    },
  });
};

watch(
  () => props.data,
  () => {
    GameStatus.value = props.data ?? null;
    useProposalList();
    useRemovedList();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_text_field, {
            width: "200",
            "prepend-inner-icon": "mdi-account",
            height: "20",
            density: "compact",
            variant: "outlined",
            placeholder: "请输入小组数",
            rounded: "",
            "hide-details": "",
            min: 0,
            modelValue: proposalNum.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((proposalNum).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        (ProposalStatus() === 2)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              variant: "outlined",
              color: "primary",
              onClick: useSubmitProposal
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("提交提案")
              ])),
              _: 1,
              __: [7]
            }))
          : _createCommentVNode("", true),
        (ProposalStatus() === 3)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              variant: "outlined",
              color: "primary",
              onClick: useSubmitVote
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("提交投票")
              ])),
              _: 1,
              __: [8]
            }))
          : _createCommentVNode("", true),
        (ProposalStatus() === 4)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 2,
              variant: "outlined",
              color: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('update')))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("开始淘汰赛")
              ])),
              _: 1,
              __: [9]
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_card, {
        rounded: "",
        "min-height": "650",
        class: "ma-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_data_table, {
            items: proposalList.value ? GetTableData() : [],
            "hide-default-footer": "",
            "no-data-text": "请先提交游戏设置"
          }, {
            top: _withCtx(() => [
              _createVNode(_component_v_toolbar, { flat: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "medium-emphasis",
                        icon: "mdi-book-multiple",
                        size: "x-small",
                        start: ""
                      }),
                      _cache[10] || (_cache[10] = _createTextVNode(" 提案列表 "))
                    ]),
                    _: 1,
                    __: [10]
                  })
                ]),
                _: 1
              })
            ]),
            "item.是否被选中": _withCtx(({ value }) => [
              (ProposalStatus() === 4)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    color: value ? 'green' : 'red'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(value ? "选中" : "落选"), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"]))
                : _createCommentVNode("", true)
            ]),
            "item.操作": _withCtx(({ index }) => [
              (ProposalStatus() === 2)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    color: "medium-emphasis",
                    icon: "mdi-pencil",
                    size: "small",
                    onClick: ($event: any) => (handleEditProp(index))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (ProposalStatus() === 3)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    class: "px-2",
                    "prepend-icon": "mdi-vote",
                    onClick: 
              () => {
                showOverlay.value = true;
                proposalIndex.value = index;
              }
            ,
                    variant: "text"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("投票")
                    ])),
                    _: 2,
                    __: [11]
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["items"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_overlay, {
      modelValue: showOverlay.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showOverlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        (ProposalStatus() === 2)
          ? (_openBlock(), _createBlock(SubmitPropOne, {
              key: 0,
              team: proposalList.value[proposalIndex.value],
              list: teamList.value,
              onSubmit: handleSubmitPropOne,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (showOverlay.value = false))
            }, null, 8, ["team", "list"]))
          : _createCommentVNode("", true),
        (ProposalStatus() === 3)
          ? (_openBlock(), _createBlock(SubmitVote, {
              key: 1,
              class: "pa-8",
              width: "600",
              list: teamList.value,
              votes: _unref(voteMap).get(proposalIndex.value),
              "proposer-id": proposalList.value[proposalIndex.value].id,
              onSubmit: handleVote,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (showOverlay.value = false))
            }, null, 8, ["list", "votes", "proposer-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_overlay, {
      modelValue: _unref(isTile),
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(isTile) ? (isTile).value = $event : isTile = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        (_unref(isTile))
          ? (_openBlock(), _createBlock(TileSelect, {
              key: 0,
              "tile-options": tileOptions.value,
              onClose: _cache[5] || (_cache[5] = ($event: any) => (_isRef(isTile) //@ts-ignore
 ? isTile.value = false : isTile = false)),
              onSubmit: useSubmitTile
            }, null, 8, ["tile-options"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})